import { sendvalidcode, sendmodifycode } from '@/api/user';
export default {
  props: {
    value: {
      type: String
    },
    type: {
      type: String,
      default: 'email'
    },
    account: {
      type: String
    },
    islogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      time: 60000,
      isget: true
    };
  },
  methods: {
    start() {
      this.$refs.countDown.start();
    },
    setInputValue(val) {
      this.$emit('input', val);
    },
    handleGetCode() {
      const {
        type,
        account
      } = this;
      this.isget = false;
      this.start();
      if (this.islogin) {
        sendmodifycode({
          type
        }).then(res => {
          this.$toast('验证码已发送');
        }).catch(() => {});
      } else {
        sendvalidcode({
          type,
          account: type === 'phone' ? `86${account}` : account
        }).then(res => {
          this.$toast('验证码已发送');
        }).catch(() => {});
      }
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.isget = true;
      this.reset();
    }
  }
};